import PropTypes from 'prop-types';
import React from 'react';

const Settings = ({
  value,
  onChange,
}) => (
  <div>
    <Row
      label="name"
    >
      <input
        type="text"
        value={value.name}
        onChange={x => onChange({...value, name: x.target.value})}
      /> 
    </Row>
    <Row
      label="birthday"
    >
      <input
        type="text"
        value={value.birthday}
        onChange={x => onChange({...value, birthday: x.target.value})}
      /> 
    </Row>
    
    <Row
      label="estimated lifespan in years"
    >
      <input
        type="text"
        value={value.maxAge}
        onChange={x => onChange({...value, maxAge: x.target.value})}
      /> 
    </Row>
  </div>
);

Settings.propTypes = {
  value: PropTypes.shape({
    birthday: PropTypes.string.isRequired,
    maxAge: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

const Row = ({
  label,
  children,
}) => (
  <div>
    <div>
      {label}
    </div>
    <div>
      {children}
    </div>
  </div>
);

Row.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element,
};

export default Settings;
